import React from "react";
import StorytellingGuide from "./StorytellingGuide";

const PostStoryRightColumn: React.FC<{}> = () => (
  <div className="RightColumn-ai col-xs-12 col-sm-6 col-lg-4">
    <StorytellingGuide />
  </div>
);

export default PostStoryRightColumn;
